import { render, staticRenderFns } from "./PersistAdminConfigInternationalView.vue?vue&type=template&id=14ce2b15&"
import script from "./PersistAdminConfigInternationalView.vue?vue&type=script&lang=ts&"
export * from "./PersistAdminConfigInternationalView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports